/**
 * Geolocation / 距離計算ユーティリティ。
 * Places API や外部サービスには一切問い合わせず、純粋な数学計算のみ。
 */

export interface LatLng {
  lat: number;
  lng: number;
}

const EARTH_RADIUS_KM = 6371;

/**
 * 2 地点間の大円距離を km で返す (Haversine formula)。
 *
 * 用途: 店舗を「現在地からの距離」で並び替える粗い指標。
 * Haversine は球面近似なので地球楕円体を考慮しないが、
 * 数 100 km スケールでは誤差 < 0.5% で十分実用的。
 */
export function distanceKm(a: LatLng, b: LatLng): number {
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const dLat = lat2 - lat1;
  const dLng = toRad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  return EARTH_RADIUS_KM * c;
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
